import * as React from 'react';

import { Image } from './careers-intro-triangle1.styles';

export const Triangle1View = ({ imageSrc }) => <Image src={imageSrc} alt="" />;
